import {Button, Typography, Card, Modal, Flex} from 'antd';
import {useState} from "react";
import {FaSearch} from "react-icons/fa";
import {Link} from "react-router-dom";
import * as https from "node:https";
const Quests = () => {

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Flex gap={12} style={{margin:24}}>
            <Card
                hoverable
                onClick={showModal}
                style={{
                    width: 300,
                    textAlign: 'center',
                    cursor: 'pointer',
                    position: 'relative',
                }}
                cover={
                    <img
                        alt="Quest"
                        src="../images/quest/quest1.jpeg"
                        style={{ height: 200, objectFit: 'cover' }}
                    />
                }
            >
                <Card.Meta
                    title="Квест: Тень Завещания"
                    description={
                        <>
                            <p>
                                В роли детектива вы отправляетесь в роскошное поместье, где подменили
                                завещание богатого бизнесмена. Среди подозреваемых — наследники, адвокат и прислуга,
                                каждый хранит свои тайны. Ваша задача — опросить всех, найти улики и вычислить виновного.
                            </p>
                            <p style={{ color: '#999', fontStyle: 'italic', marginTop: 8 }}>
                                🔧 Квест находится в разработке
                            </p>
                        </>
                    }
                />
            </Card>

            <Modal
                title="Скоро в разработке!"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="ok" type="primary" onClick={handleOk}>
                        Понятно
                    </Button>,
                ]}
            >
                <p>Мы запускаем новый раздел «Квест»!</p>
                <p>
                    В ближайшее время пользователям будет доступна первая интерактивная история.
                    Вы окажетесь в роли детектива и будете общаться с ИИ, чтобы расследовать дело,
                    разгадывать улики и раскрывать тайну.
                </p>
                <p><strong>Доступно только для премиум-пользователей.</strong></p>
                <p>Следите за обновлениями в нашем <Link to={'https://t.me/geekenglishru'}  target="_blank">телеграмм канале</Link></p>
            </Modal>
        </Flex>
    );
};

export default Quests;
